module.exports = __webpack_public_path__ + "static/media/icon-award-04.f09413b5.svg";